<template>
    <template v-if="totalPages > 1">
        <ShadPagination v-model:page="currentPage" :items-per-page="itemsPerPage" :total="totalItems" :sibling-count="siblingCount" show-edges>
            <ShadPaginationList v-slot="{ items }" class="flex items-center gap-1">
                <ShadPaginationFirst />
                <ShadPaginationPrev />
                <template v-for="(item, index) in items" :key="index">
                    <ShadPaginationListItem v-if="item.type === 'page'" :value="item.value" as-child>
                        <ShadButton class="w-10 h-10 p-0" :class="{'hover:bg-neutral-900': item.value === currentPage}" :variant="item.value === currentPage ? 'default' : 'outline'">
                            {{ item.value }}
                        </ShadButton>
                    </ShadPaginationListItem>
                    <ShadPaginationEllipsis v-else :index="index" />
                </template>
                <ShadPaginationNext />
                <ShadPaginationLast />
            </ShadPaginationList>
        </ShadPagination>
    </template>
</template>

<script setup lang="ts">
const props = defineProps({
    totalItems: {
        type: Number,
        required: true,
        default: 0,
    },
    itemsPerPage: {
        type: Number,
        required: true,
        default: 10,
    },
    siblingCount: {
        type: Number,
        default: 0,
    },
    modelValue: {
        type: Number,
        default: 1,
    },
})

const emit = defineEmits(['update:modelValue'])

const currentPage = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage))
</script>